import { accessibilityConfiguration } from './Accessibility/configurations/Accessibility.configuration.js';
import { accordionConfiguration } from './Accordion/configurations/Accordion.configuration.js';
import { accordionPanelConfiguration } from './AccordionPanel/configurations/AccordionPanel.configuration.js';
import { actionsConfiguration } from './Actions/configurations/Actions.configuration.js';
import { applicationConfiguration } from './Application/configurations/Application.configuration.js';
import { applicationEmbedConfiguration } from './ApplicationEmbed/configurations/ApplicationEmbed.configuration.js';
import { asOfDateConfiguration } from './AsOfDate/configurations/AsOfDate.configuration.js';
import { assetConfiguration } from './Asset/configurations/Asset.configuration.js';
import { badgeConfiguration } from './Badge/configurations/Badge.configuration.js';
import { buttonConfiguration } from './Button/configurations/Button.configuration.js';
import { buttonFlatConfiguration } from './ButtonFlat/configurations/ButtonFlat.configuration.js';
import { buttonRaisedConfiguration } from './ButtonRaised/configurations/ButtonRaised.configuration.js';
import { calendarInputConfiguration } from './CalendarInput/configurations/CalendarInput.configuration.js';
import { cardConfiguration } from './Card/configurations/Card.configuration.js';
import { carouselConfiguration } from './Carousel/configurations/Carousel.configuration.js';
import { checkboxConfiguration } from './Checkbox/configurations/Checkbox.configuration.js';
import { clickLayerConfiguration } from './ClickLayer/configurations/ClickLayer.configuration.js';
import { confirmDialogConfiguration } from './ConfirmDialog/configurations/ConfirmDialog.configuration.js';
import { contextMenuConfiguration } from './ContextMenu/configurations/ContextMenu.configuration.js';
import { CopyButtonConfiguration } from './CopyButton/configurations/CopyButton.configuration.js';
import { dateDropdownConfiguration } from './DateDropdown/configurations/DateDropdown.configuration.js';
import { datePickerConfiguration } from './DatePicker/configurations/DatePicker.configuration.js';
import { dateRangeInputConfiguration } from './DateRangeInput/configurations/DateRangeInput.configuration.js';
import { dateSelectionConfiguration } from './DateSelection/configurations/DateSelection.configuration.js';
import { definitionListConfiguration } from './DefinitionList/configurations/DefinitionList.configuration.js';
import { dialogConfiguration } from './Dialog/configurations/Dialog.configuration.js';
import { dividerConfiguration } from './Divider/configurations/Divider.configuration.js';
import { dropdownConfiguration } from './Dropdown/configurations/Dropdown.configuration.js';
import { gridConfiguration } from './Grid/configurations/Grid.configuration.js';
import { headingConfiguration } from './Heading/configurations/Heading.configuration.js';
import { iconConfiguration } from './Icon/configurations/Icon.configuration.js';
import { iconInputConfiguration } from './IconInput/configurations/IconInput.configuration.js';
import { imageConfiguration } from './Image/configurations/Image.configuration.js';
import { imagePickerConfiguration } from './ImagePicker/configurations/ImagePicker.configuration.js';
import { inputConfiguration } from './Input/configurations/Input.configuration.js';
import { labelConfiguration } from './Label/configurations/Label.configuration.js';
import { labelledInputConfiguration } from './LabelledInput/configurations/LabelledInput.configuration.js';
import { legendConfiguration } from './Legend/configurations/Legend.configuration.js';
import { linkConfiguration } from './Link/configurations/Link.configuration.js';
import { listConfiguration } from './List/configurations/List.configuration.js';
import { loadingIndicatorConfiguration } from './LoadingIndicator/configurations/LoadingIndicator.configuration.js';
import { menuConfiguration } from './Menu/configurations/Menu.configuration.js';
import { menuItemConfiguration } from './MenuItem/configurations/MenuItem.configuration.js';
import { menuListConfiguration } from './MenuList/configurations/MenuList.configuration.js';
import { modalConfiguration } from './Modal/configurations/Modal.configuration.js';
import { morningStarConfiguration } from './MorningStar/configurations/MorningStar.configuration.js';
import { morningstarStyleBoxConfiguration } from './MorningstarStyleBox/configurations/MorningstarStyleBox.configuration.js';
import { noDataPlaceholderConfiguration } from './NoDataPlaceholder/configurations/NoDataPlaceholder.configuration.js';
import { numberPickerConfiguration } from './NumberPicker/configurations/NumberPicker.configuration.js';
import { pagingConfiguration } from './Paging/configurations/Paging.configuration.js';
import { pillConfiguration } from './Pill/configurations/Pill.configuration.js';
import { radioButtonsConfiguration } from './RadioButtons/configurations/RadioButtons.configuration.js';
import { redirectButtonConfiguration } from './RedirectButton/configurations/RedirectButton.configuration.js';
import { savedSearchConfiguration } from './SavedSearch/configurations/SavedSearch.configuration.js';
import { savedSearchListConfiguration } from './SavedSearchList/configurations/SavedSearchList.configuration.js';
import { scaleConfiguration } from './Scale/configurations/Scale.configuration.js';
import { scaleLegendConfiguration } from './ScaleLegend/configurations/ScaleLegend.configuration.js';
import { searchConfiguration } from './Search/configurations/Search.configuration.js';
import { sortButtonConfiguration } from './SortButton/configurations/SortButton.configuration.js';
import { superscriptConfiguration } from './Superscript/configurations/Superscript.configuration.js';
import { tabConfiguration } from './Tab/configurations/Tab.configuration.js';
import { tableConfiguration } from './Table/configurations/Table.configuration.js';
import { tableGroupingConfiguration } from './TableGrouping/configurations/TableGrouping.configuration.js';
import { tabsConfiguration } from './Tabs/configurations/Tabs.configuration.js';
import { textConfiguration } from './Text/configurations/Text.configuration.js';
import { themeProviderConfiguration } from './ThemeProvider/configurations/ThemeProvider.configuration.js';
import { toggleButtonConfiguration } from './ToggleButton/configurations/ToggleButton.configuration.js';
import { tooltipConfiguration } from './Tooltip/configurations/Tooltip.configuration.js';
import { translateConfiguration } from './Translate/configurations/Translate.configuration.js';
import { virtualizedListConfiguration } from './VirtualizedList/configurations/VirtualizedList.configuration.js';
import { visuallyHiddenConfiguration } from './VisuallyHidden/configurations/VisuallyHidden.configuration.js';
import { weightingBarConfiguration } from './WeightingBar/configurations/WeightingBar.configuration.js';
import { IBaseConfiguration } from './IBaseConfiguration.js';
/* [Component: import] */
/* [ChartComponent: import] */

export const baseConfiguration: IBaseConfiguration = {
	actions: actionsConfiguration,
	application: applicationConfiguration,
	asset: assetConfiguration,
	badge: badgeConfiguration,
	button: buttonConfiguration,
	card: cardConfiguration,
	carousel: carouselConfiguration,
	checkbox: checkboxConfiguration,
	grid: gridConfiguration,
	icon: iconConfiguration,
	image: imageConfiguration,
	link: linkConfiguration,
	list: listConfiguration,
	text: textConfiguration,
	translate: translateConfiguration,
	contextMenu: contextMenuConfiguration,
	tabs: tabsConfiguration,
	tab: tabConfiguration,
	table: tableConfiguration,
	asOfDate: asOfDateConfiguration,
	tooltip: tooltipConfiguration,
	heading: headingConfiguration,
	definitionList: definitionListConfiguration,
	search: searchConfiguration,
	input: inputConfiguration,
	pill: pillConfiguration,
	dropdown: dropdownConfiguration,
	accordion: accordionConfiguration,
	accordionPanel: accordionPanelConfiguration,
	redirectButton: redirectButtonConfiguration,
	dateSelection: dateSelectionConfiguration,
	applicationEmbed: applicationEmbedConfiguration,
	morningStar: morningStarConfiguration,
	iconInput: iconInputConfiguration,
	buttonRaised: buttonRaisedConfiguration,
	buttonFlat: buttonFlatConfiguration,
	imagePicker: imagePickerConfiguration,
	loadingIndicator: loadingIndicatorConfiguration,
	labelledInput: labelledInputConfiguration,
	label: labelConfiguration,
	noDataPlaceholder: noDataPlaceholderConfiguration,
	confirmDialog: confirmDialogConfiguration,
	dialog: dialogConfiguration,
	paging: pagingConfiguration,
	radioButtons: radioButtonsConfiguration,
	dateDropdown: dateDropdownConfiguration,
	clickLayer: clickLayerConfiguration,
	calendarInput: calendarInputConfiguration,
	dateRangeInput: dateRangeInputConfiguration,
	numberPicker: numberPickerConfiguration,
	toggleButton: toggleButtonConfiguration,
	accessibility: accessibilityConfiguration,
	visuallyHidden: visuallyHiddenConfiguration,
	sortButton: sortButtonConfiguration,
	savedSearch: savedSearchConfiguration,
	savedSearchList: savedSearchListConfiguration,
	scale: scaleConfiguration,
	themeProvider: themeProviderConfiguration,
	scaleLegend: scaleLegendConfiguration,
	weightingBar: weightingBarConfiguration,
	legend: legendConfiguration,
	virtualizedList: virtualizedListConfiguration,
	tableGrouping: tableGroupingConfiguration,
	CopyButton: CopyButtonConfiguration,
	morningstarStyleBox: morningstarStyleBoxConfiguration,
	superscript: superscriptConfiguration,
	modal: modalConfiguration,
	datePicker: datePickerConfiguration,
	menu: menuConfiguration,
	menuList: menuListConfiguration,
	menuItem: menuItemConfiguration,
	divider: dividerConfiguration,
	/* [Component: interface] */
	/* [ChartComponent: interface] */
};
